export default function Bullet({ text, className = "" }) {
  return (
    <div className={`flex gap-1.5 ${className}`}>
      <span className="flex-shrink-0">·</span>
      <span>{typeof text === "string" ? text.trim() : text}</span>
    </div>
  );
}
